<template>
  <div>
    <div class="tab">
      <ul>
        <li :class="{'is-active': isActiveTab(constantes.PRODUIT_FACES)}"
            @click="updateActiveTab(constantes.PRODUIT_FACES)" v-if="moduleFaceUnitaireIsActive">
          {{ $t('cartographie.tabs.recherche.faces') }}
        </li>
        <li :class="{'is-active': isActiveTab(constantes.PRODUIT_ECRANS)}"
            @click="updateActiveTab(constantes.PRODUIT_ECRANS)" v-if="moduleEcranNumIsActive">
          {{ $t('cartographie.tabs.recherche.ecrans') }}
        </li>
        <li :class="{'is-active': activeTab === constantes.CLIENTS}"
            @click="activeTab = constantes.CLIENTS">
          {{ $t('cartographie.tabs.recherche.clients') }}
        </li>
        <li :class="{'is-active': activeTab === constantes.RESEAUX}"
          @click="updateActiveTab(constantes.RESEAUX)" v-if="moduleReseauTempoIsActive">
          {{ $t('cartographie.tabs.recherche.reseaux') }}
        </li>
      </ul>
    </div>
    <store-recherche-provider
      key="produitFaces"
      v-if="activeTab === constantes.PRODUIT_FACES"
      name="produitFaceCartographie"
      :copy="storeProduitFace"
      :copyChanges="changesProduitFaceStore">
      <liste-produit-face
        :isCartographie="true"
        :selection="selection.produitFaces"
        @addSelection="value => addSelection('produitFaces', value)"
        @removeSelection="value => removeSelection('produitFaces', value)">
      </liste-produit-face>
    </store-recherche-provider>
    <store-recherche-provider
      key="produitEcrans"
      v-if="activeTab === constantes.PRODUIT_ECRANS"
      name="produitEcranCartographie"
      :copy="storeProduitEcranNumerique"
      :copyChanges="changesEcranStore">
      <liste-produit-ecran-numerique
        :isCartographie="true"
        :selection="selection.produitEcrans"
        @addSelection="value => addSelection('produitEcrans', value)"
        @removeSelection="value => removeSelection('produitEcrans', value)">
      </liste-produit-ecran-numerique>
    </store-recherche-provider>
    <store-recherche-provider
      key="clients"
      v-if="activeTab === constantes.CLIENTS"
      name="clientCartographie"
      :copy="storeClient"
      :copyChanges="changesClientStore">
      <liste-clients
        :isCartographie="true"
        :selection="selection.clients"
        @addSelection="value => addSelection('clients', value)"
        @removeSelection="value => removeSelection('clients', value)">
      </liste-clients>
    </store-recherche-provider>
    <store-recherche-provider
      key="reseaux"
      v-if="activeTab === constantes.RESEAUX"
      name="produitReseauTempoCartographie"
      :copy="storeProduitReseau"
      :copyChanges="changesProduitReseauStore">
      <liste-reseaux
        :typeReseau="[CATEGORIE_REGROUPEMENT]"
        :referenceTable="REFERENCE_TABLE_PRODUIT_RESEAU_TEMPO"
        storeName="produitReseauTempoCartographie"
        :selection="selection.reseaux"
        :isSelection="true"
        @addSelection="value => addSelection('reseaux', value)"
        @removeSelection="value => removeSelection('reseaux', value)">
      </liste-reseaux>
    </store-recherche-provider>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import storeRechercheProvider from '@/components/general/store/storeRechercheProvider';
import storeProduitFace, { initialState as initialStateFace } from '@/store/modules/produitFace';
import storeProduitEcranNumerique, { initialState as initialStateEcran } from '@/store/modules/produitEcranNumerique';
import storeClient, { initialState as initialStateClient } from '@/store/modules/clients';
import listeProduitFace from '@/views/bodac/catalogue/l_produitFace';
import listeProduitEcranNumerique from '@/views/bodac/catalogue/l_produitEcranNumerique';
import listeClients from '@/views/bodac/clients/clients/l_Clients';
import listeReseaux from '@/components/catalogue/produitReseau/listeProduitReseau';
import { COULEUR_PUCE_DEFAULT } from '@/configuration/general/carteConf';
import * as allTypes from '@/store/mutation-type';
import { CATEGORIE_REGROUPEMENT } from '@/configuration/catalogue/produitConf';
import { REFERENCE_TABLE_PRODUIT_RESEAU_TEMPO } from '@/configuration/general/referenceTableConf';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import storeProduitReseau from '@/store/modules/produitReseau';
import genererCritereRecherche
  from '@/services/catalogue/genererCriteresRecherche/genererCritereRechercheProduitReseauTempo';
import { RESET_STATE } from '@/store/mutation-type';
import cloneDeep from 'lodash/cloneDeep';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    selection: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      CATEGORIE_REGROUPEMENT,
      REFERENCE_TABLE_PRODUIT_RESEAU_TEMPO,
      storeProduitFace,
      storeClient,
      storeProduitReseau,
      storeProduitEcranNumerique,
      activeTab: null,
      constantes: {
        PRODUIT_FACES: 'produitFaces',
        PRODUIT_ECRANS: 'produitEcrans',
        CLIENTS: 'clients',
        RESEAUX: 'reseaux',
      },
      changesProduitFaceStore: {
        state: initialStateFace(true),
        mutations: {
          [allTypes.RESET_STATE](state) {
            const s = initialStateFace(true);
            Object.keys(state).forEach(key => {
              state[key] = s[key];
            });
          },
        },
      },
      changesClientStore: {
        state: initialStateClient(true),
        mutations: {
          [allTypes.RESET_STATE](state) {
            const s = initialStateClient(true);
            Object.keys(state).forEach(key => {
              state[key] = s[key];
            });
          },
        },
      },
      changesEcranStore: {
        state: initialStateEcran(true),
        mutations: {
          [allTypes.RESET_STATE](state) {
            const s = initialStateEcran(true);
            Object.keys(state).forEach(key => {
              state[key] = s[key];
            });
          },
        },
      },
    };
  },
  components: {
    storeRechercheProvider,
    listeProduitFace,
    listeClients,
    listeReseaux,
    listeProduitEcranNumerique,
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    moduleEcranNumIsActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleEcranNumerique.key);
    },
    moduleFaceUnitaireIsActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleProduitFaceUnitaire.key);
    },
    moduleReseauTempoIsActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleProduitReseauTempo.key);
    },
    changesProduitReseauStore() {
      const newState = {
        items: [],
        total: 0,
        criteresRecherche: genererCritereRecherche(),
        lastPayload: {},
      };
      newState.criteresRecherche.categories = [CATEGORIE_REGROUPEMENT];
      return {
        state: cloneDeep(newState),
        mutations: {
          [RESET_STATE](state) {
            const s = cloneDeep(newState);
            Object.keys(state).forEach(key => {
              state[key] = s[key];
            });
          },
        },
      };
    },
  },
  methods: {
    addSelection(key, value) {
      const valueToadd = value.filter(v => !this.selection[key].map(s => s.id).includes(v.id));
      valueToadd.forEach(element => {
        this.$set(element, 'color', element.couleurHtmlRgb ?? COULEUR_PUCE_DEFAULT);
        this.$set(element, 'selected', false);
      });
      this.selection[key] = this.selection[key].concat(valueToadd);
    },
    removeSelection(key, value) {
      this.selection[key] = this.selection[key].filter(s => !value.map(v => v.id).includes(s.id));
    },
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    isActiveTab(tab) {
      return this.activeTab === tab;
    },
    updateActiveTab(activeTab) {
      this.activeTab = activeTab;
    },
  },
  async mounted() {
    await this.loadParametresInterne([
      PARAMETRES_INTERNE_KEYS.moduleEcranNumerique.key,
      PARAMETRES_INTERNE_KEYS.moduleProduitFaceUnitaire.key,
      PARAMETRES_INTERNE_KEYS.moduleProduitReseauTempo.key,
    ]);
    if (this.moduleFaceUnitaireIsActive) {
      this.updateActiveTab(this.constantes.PRODUIT_FACES);
    } else if (this.moduleEcranNumIsActive) {
      this.updateActiveTab(this.constantes.PRODUI_ECRANS);
    } else {
      this.updateActiveTab(this.constantes.CLIENTS);
    }
  },
};
</script>

<style>

</style>
